import { AnyTaskTemplate, SimpleTask } from '../task'
import { TaskStatus } from '../TaskStatus'
import { TaskType } from '../TaskType'
import {
    BaseTaskFormPayload,
    baseTaskFormPayloadFromTask,
    BaseTaskPayloadValidation,
    baseValidateTask,
    initialBaseTaskPayload,
} from './BaseTaskFormPayload'

export interface SimpleTaskFormPayload extends BaseTaskFormPayload {
    type: TaskType.Simple
}

export const initialSimpleTaskPayload: SimpleTaskFormPayload = {
    type: TaskType.Simple,
    status: TaskStatus.Todo,
    ...initialBaseTaskPayload,
}

export type SimpleTaskPayloadValidation = BaseTaskPayloadValidation

export const validateSimpleTask = (t: SimpleTaskFormPayload): SimpleTaskPayloadValidation =>
    baseValidateTask(t)

export const simpleTaskFormPayloadFromTask = (
    t: SimpleTask | AnyTaskTemplate,
    isClone = false,
): SimpleTaskFormPayload => ({
    type: TaskType.Simple,
    ...baseTaskFormPayloadFromTask(t, isClone),
})
